import {
  icon,
  library,
} from '@fortawesome/fontawesome-svg-core';

import {
  faUsers,
  faSearch,
  faDownload,
  faRocket,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faWindows,
  faApple,
  faUbuntu,
} from '@fortawesome/free-brands-svg-icons';

const faFranzIcon = {
  prefix: 'fad',
  iconName: 'franz',
  icon: [
    512,
    512,
    [],
    'f0000',
    [
      'M256,1 C396.832635,1 511,115.167365 511,256 C511,396.832635 396.832635,511 256,511 C115.167365,511 1,396.832635 1,256 C1,115.167365 115.167365,1 256,1 Z M256,39 C136.154186,39 39,136.154186 39,256 C39,375.845814 136.154186,473 256,473 C375.845814,473 473,375.845814 473,256 C473,136.154186 375.845814,39 256,39 Z',
      'M402.109652,316.234723 C400.045993,324.536729 396.626258,334.437372 391.277168,343.30108 C380.876756,360.535101 354.874958,358.565146 343.433891,358.565146 C331.992824,358.565146 323.672187,354.625962 323.672187,347.240264 L323.672187,347.240264 L323.672187,323.942328 C327.363597,324.32818 331.052704,324.52801 334.733369,324.52801 C361.105075,324.52801 383.91814,321.663545 402.109652,316.234723 Z M118.038835,316.234723 C135.532653,320.999424 156.89849,323.498928 181.28874,323.498928 C186.341242,323.498928 191.408386,323.119398 196.476299,322.376809 L196.476299,322.376809 L196.476299,346.896494 C196.476299,354.505044 188.121986,358.563088 176.634612,358.563088 C165.148009,358.563088 139.040972,360.592484 128.597695,342.83845 C123.492024,334.158684 120.137816,324.512503 118.038835,316.234723 Z M302.444293,208.118218 C313.795051,208.118218 326.911653,221.844826 340.798595,236.377853 C347.401621,243.287944 353.638368,249.815367 358.672182,253.677806 C368.752148,261.413335 388.60672,267.947606 402.030225,267.947606 C407.006977,267.947606 408.972539,266.98599 409.456026,266.691571 C412.845831,264.626075 416.132307,263.578492 419.226776,263.578492 C423.605146,263.578492 427.29954,265.837224 428.867209,269.472953 C430.798843,273.955422 429.191076,279.461889 424.564408,284.201498 C409.954164,299.170447 376.562734,307.754997 332.951767,307.754997 C304.316552,307.754997 278.46659,292.93516 263.823187,279.066287 C260.852096,276.252953 256.97572,276.109928 256.229284,276.109928 L256.229284,276.109928 L256.129811,276.111449 L255.603913,276.157096 L255.46357,276.106885 L255.439666,276.109928 C254.69323,276.109928 250.817625,276.252953 247.846534,279.066287 C233.203131,292.93516 207.352398,307.754997 178.717183,307.754997 C135.106216,307.754997 101.714786,299.170447 87.1053127,284.201498 C82.4786453,279.461128 80.8693362,273.955422 82.801741,269.472953 C84.3694101,265.837224 88.063804,263.578492 92.4429447,263.578492 C95.536643,263.578492 98.8238901,264.626075 102.213695,266.691571 C102.697182,266.98599 104.662744,267.947606 109.638725,267.947606 C123.063001,267.946845 142.918344,261.412575 152.996768,253.677806 C158.030582,249.815367 164.267329,243.288705 170.870355,236.378613 C184.756526,221.845587 197.873899,208.118218 209.225428,208.118218 C217.293564,208.118218 226.586226,211.827742 235.572756,215.416303 C243.057933,218.404616 250.797576,221.494871 255.834475,221.494871 C260.871374,221.494871 268.611788,218.404616 276.096965,215.416303 C285.083495,211.827742 294.375386,208.118218 302.444293,208.118218 Z M394.176382,153 C400.228116,153 399.671765,169.359844 399.671765,187.536938 C399.671765,197.288463 400.936936,226.617384 402.109652,252.636779 C391.648474,252.450532 374.987959,247.18733 367.418021,241.622147 C365.285884,240.05476 362.618482,237.666506 359.711022,234.895028 C360.961595,233.734625 362.194325,232.66083 363.401104,231.682842 C382.635754,216.102476 378.789148,153 394.176382,153 Z M125.147453,153 C138.959209,153 135.506452,216.301636 152.771693,231.931944 C153.202651,232.32176 153.639433,232.738486 154.07767,233.158288 C150.754491,236.777348 147.667903,239.965073 145.310011,241.902619 C139.389439,246.766475 127.272394,251.40044 118.038835,252.636779 C119.087838,226.614456 120.214734,197.389031 120.214734,187.64671 L120.214187,186.554902 C120.19716,168.761584 119.824703,153 125.147453,153 Z',
    ],
  ],
};

library.add(
  faUsers,
  faSearch,
  faFranzIcon,
  faWindows,
  faApple,
  faUbuntu,
  faDownload,
  faRocket,
);

export const iconShare = icon({
  prefix: 'fad',
  iconName: 'users',
});
export const iconSearch = icon({
  prefix: 'fad',
  iconName: 'search',
});
export const iconFranz = icon({
  prefix: 'fad',
  iconName: 'franz',
});
export const iconDownload = icon({
  prefix: 'fad',
  iconName: 'download',
});
export const iconWindows = icon({
  prefix: 'fab',
  iconName: 'windows',
});
export const iconApple = icon({
  prefix: 'fab',
  iconName: 'apple',
});
export const iconUbuntu = icon({
  prefix: 'fab',
  iconName: 'ubuntu',
});
export const iconRocket = icon({
  prefix: 'fad',
  iconName: 'rocket',
});
